module.exports = __webpack_public_path__ + "content/views/visualizers/5c58d0e1d2ec48e766846af99eaeb6f8.png";